var map = {
	"./永祥股份_1.png": "9df1",
	"./通威农牧_1.png": "181a",
	"./通威太阳能_1.png": "49c4",
	"./通威新能源_1.png": "a9c3",
	"./通威集团_1.png": "21bd",
	"./高效组件 通威智造_1.png": "bc4d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "56d4";